import {
  DEDUCTION,
  FULL_DEDUCTION,
  getDeduction,
  HALF_DEDUCTION,
  NONE_DEDUCTION,
} from "../../constants/deduction";

//控除金額を計算する
export function calcAfterDeductionPrice(beforeDeductionPrice, deductionType) {
  if (deductionType === FULL_DEDUCTION) {
    return 0;
  } else if (deductionType === HALF_DEDUCTION) {
    return Math.ceil(beforeDeductionPrice / 2.0); // 少数点を切り上げ
  } else {
    return beforeDeductionPrice;
  }
}

// カテゴリマスタの上限から今期の購入実績を差し引いた「残り枠」を求める
function getCurrentLimitArray(categoryMaster, categoryCounts) {
  // categoryMasterをマップでコピー
  const updatedCategoryMaster = categoryMaster.map((masterItem) => {
    // categoryCountsから、対応するcategory_idを持つアイテムを探す
    const matchingCategory = categoryCounts.find(
      (countItem) => countItem.category_id === masterItem.cid
    );

    // 一致するcategory_idがある場合、limitを更新
    if (matchingCategory) {
      return {
        ...masterItem,
        limit: masterItem.limit - matchingCategory.quantity, // limitからquantityを引く
      };
    }

    // 一致しない場合は、そのままのオブジェクトを返す
    return masterItem;
  });

  return updatedCategoryMaster;
}

// 購入依頼者有・仕入先無の場合の控除判定。
// カート内の各商品に控除区分(deduction_id等)を設定して返す純関数。
// 残り枠はカート内の並び順に消し込む(同一カテゴリ2行目以降は枠を消費済みとして判定される)。
export function getUpdatedDeductionProducts(
  productsInCart,
  categoryCounts,
  categoryMaster
) {
  const currentLimits = getCurrentLimitArray(categoryMaster, categoryCounts);

  const copyCurrentLimits = currentLimits.map((limit) => ({ ...limit }));
  const updatedProducts = productsInCart.map((product) => {
    //product.categoryがcurrentLimitsにあるかどうか
    const matchingCategory = copyCurrentLimits.find(
      (row) => row.cid === product.category
    );
    if (matchingCategory) {
      const beforeLimit = matchingCategory.limit;
      const afterLimit = beforeLimit - product.quantity;

      if (afterLimit >= 0) {
        //控除区分に応じた控除を設定する適正をセット
        const { id, name } = getDeduction(matchingCategory.deduction);
        matchingCategory.limit = afterLimit;

        return {
          ...product,
          deduction_price: calcAfterDeductionPrice(
            Number(product.price) * Number(product.quantity),
            id
          ), //控除金額
          deduction_id: id, //控除区分
          deduction_name: name, //控除区分名
          deduction_is_valid: true,
          deduction_correct_count:
            Number(beforeLimit) - Number(product.quantity) >= 0
              ? Number(product.quantity)
              : Number(beforeLimit), //控除区分が適用できる数量
        };
      }
      if (beforeLimit > 0 && afterLimit < 0) {
        //控除なし、不適正をセット
        matchingCategory.limit = afterLimit;

        return {
          ...product,
          deduction_price: calcAfterDeductionPrice(
            Number(product.price) * Number(product.quantity),
            NONE_DEDUCTION
          ), //控除金額
          deduction_id: NONE_DEDUCTION, //控除区分
          deduction_name: DEDUCTION.NONE_DEDUCTION, //控除区分名
          deduction_is_valid: false,
          deduction_correct_count:
            Number(beforeLimit) - Number(product.quantity) >= 0
              ? Number(product.quantity)
              : Number(beforeLimit), //控除区分が適用できる数量
        };
      }
      if (beforeLimit <= 0) {
        //控除なし、適正をセット
        matchingCategory.limit = afterLimit;
        return {
          ...product,
          deduction_price: calcAfterDeductionPrice(
            Number(product.price) * Number(product.quantity),
            NONE_DEDUCTION
          ), //控除金額
          deduction_id: NONE_DEDUCTION, //控除区分
          deduction_name: DEDUCTION.NONE_DEDUCTION, //控除区分名
          deduction_is_valid: true,
          deduction_correct_count:
            Number(beforeLimit) - Number(product.quantity) >= 0
              ? Number(product.quantity)
              : Number(beforeLimit), //控除区分が適用できる数量
        };
      }
    } else {
      //カテゴリマスタに存在しない商品の場合は控除無し
      return {
        ...product,
        deduction_price: calcAfterDeductionPrice(
          Number(product.price) * Number(product.quantity),
          NONE_DEDUCTION
        ), //控除金額
        deduction_id: NONE_DEDUCTION, //控除区分
        deduction_name: DEDUCTION.NONE_DEDUCTION, //控除区分名
        deduction_is_valid: true,
        deduction_correct_count: Number(product.quantity), //控除区分が適用できる数量
      };
    }
  });
  return updatedProducts;
}
